import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getUserList = createAsyncThunk(
  "get-user",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("user/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createUser = createAsyncThunk(
  "create-user",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("user", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editUser = createAsyncThunk(
  "edit-user",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`user/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateUser = createAsyncThunk(
  "update-user",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/user/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteUser = createAsyncThunk(
  "delete-user",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/user/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.userList;
        state.perPage = action?.payload?.data?.data?.perPage;
        state.total = action?.payload?.data?.data?.total;
      })
      .addCase(getUserList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default userSlice.reducer;
